export const getDivisor = (rounding?: string) => {
  let divisor = 1

  if (rounding) {
    switch (rounding) {
      case 'M': {
        divisor = 1000000
        break
      }
      case 'K': {
        divisor = 1000
        break
      }
      case 'AsIs':
      default: {
        break
      }
    }
  }

  return divisor
}
